import apiSlice from "./ApiSlice";

export const studentTestimonialApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET ALL JOB WITH PAGINATION
    getAllTestimonialWithPagination: builder.query({
      providesTags: ["testimonial"],
      query: (body) => {
        return {
          url: "/testimonial",
          method: "POST",
          body,
        };
      },
    }),
    // Add
    addTestimonial: builder.mutation({
      invalidatesTags: ["testimonial"],
      query: (body) => {
        return {
          url: "/testimonial/add",
          method: "POST",
          body,
        };
      },
    }),
    // DELETE
    deleteTestimonial: builder.mutation({
      invalidatesTags: ["testimonial"],
      query: ({ id }) => {
        return {
          url: `/testimonial/${id}`,
          method: "DELETE",
        };
      },
    }),
    // GET JOB BY ID
    getTestimonialById: builder.query({
      providesTags: ["testimonial"],
      query: ({ id }) => {
        return {
          url: `/testimonial/${id}`,
          method: "GET",
        };
      },
    }),
    // EDIT
    editTestimonial: builder.mutation({
      invalidatesTags: ["testimonial"],
      query: ({ body, id }) => {
        return {
          url: `/testimonial/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
  }),
});

export const {
  useGetAllTestimonialWithPaginationQuery,
  useAddTestimonialMutation,
  useDeleteTestimonialMutation,
  useEditTestimonialMutation,
  useGetTestimonialByIdQuery,
} = studentTestimonialApi;
